<ng-container>
    @if(isLoading()){
        <app-spinner></app-spinner>
    }
    <div class="mx-4 request-quote-step-container">
        <form [formGroup]="quoteSummaryForm">
            <div class="border-top border-bottom bg-secondary bg-gradient">
            <h6 class="mt-2 fw-bold fs-4 text-black mb-3 ml-2">Summary</h6>
            </div>
            <h6 class="mt-2 fw-semibold fs-4 text-black mb-3">{{IndicationNo()}} : {{this.quoteSummaryForm.get('indicationNo')?.value}}</h6>
            <h6 class="mt-2 fw-semibold fs-4 text-black mb-3">{{IndicationDate()}}  : {{this.quoteSummaryForm.get('indicationDate')?.value | date:'MM/dd/yyyy'}}</h6>
            <h6 class="mt-2 fw-semibold fs-4 text-black mb-5">Inception Date  : {{this.quoteSummaryForm.get('inceptionDate')?.value | date:'MM/dd/yyyy'}}</h6>
            <div class="border-top border-bottom bg-secondary bg-gradient">
                        <h6 class="my-2 fw-bold fs-4 text-black">Policy Locations</h6>
                    </div>
            <ng-container formArrayName="address">
                <ng-container *ngFor="let address of this.getAddressForm().controls; let i=index;" [formGroupName]="i">
                    
                    <div class="row border border-bottom border-top-0 border-2 border-secondary py-5">
                        <h6 class="fw-semibold fs-4 mb-3">#{{i+1}} -  {{address.get('streetNum')?.value}},{{address.get('streetName')?.value}}, {{address.get('unitNum')?.value ? address.get('unitNum')?.value + ',' : ''}} {{address.get('city')?.value}}, {{address.get('county')?.value}}, {{address.get('zipcode')?.value}}, {{address.get('state')?.value}}</h6>
                        <h6 class="fw-semibold fs-4 mb-5">Location TIV: {{address.get('locationTIV')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                        
                        <ng-container formArrayName="buildings">
                            <ng-container *ngFor="let building of this.getBuildingForm(i).controls; let j = index" [formGroupName]="j">
                                <h6 class="fw-semibold fs-4 mb-5">Building #{{j+1}} - Ordinance or Law: {{building.get('oandLFlag')?.value === 1 ? 'Included' : 'Excluded'}}</h6>
                            </ng-container>
                        </ng-container>
                        
                    </div>
                </ng-container>
            </ng-container>
            <div class="border-top border-bottom bg-secondary bg-gradient">

                            <h6 class="fw-bold fs-4 text-black">Policy Coverage and Deductibles</h6>
                       </div>
                        <div class="row py-2 px-3">
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Cause of Loss Form :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{ this.quoteSummaryForm.get('causeOfLoss')?.value }}</span>
                            </div>
                        
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">AOP Deductible :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{ this.quoteSummaryForm.get('aopDeductibleDescription')?.value }}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Wind/Hail :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('windDeductibleFlag')?.value === 0 ? 'Included' : 'Excluded'}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Wind/Hail Deductible :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('windDeductibleDescription')?.value}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Property Enhancement :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('propertyExtCoverageType')?.value}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Water Damage Coverage :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('waterDamageDescription')?.value}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Theft Coverage :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('vandalismDescription')?.value}}</span>
                            </div>
                        </div>
   
            <div class="row mt-3 py-5">
                    <div class="border-top border-bottom bg-secondary bg-gradient">
                    <h6 class=" my-2 fw-bold fs-4 text-black ">Policy Premium</h6>
                </div>
                <div  [style.background-color]="ragIndicationColor()" class ="mb-2 mt-2">
                 @if(indicationQuoteDetails()){
                     <p class="px-3 py-3 fw-bold">{{indicationQuoteDetails()?.description}}</p>
                    }
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Total Insured Value</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('totalInsuredValue')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Target Premium</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('targetPremium')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">TRIA Premium</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('triaPremium')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Inspection Fee</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('inspectionFee')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
            </div>   
             <div class="row mt-2 py-5 border-border">
                @if (isEqbdUnavailableForRisk()) {
                    <label class="fs-4 text-black mb-3">Equipment breakdown coverage is not available for this risk.</label>
                } @else {
                    <label class="fs-4 text-black mb-3">Equipment Breakdown Coverage can be
                        added for an additional premium of <b>{{ eqbdAdditionalPremium() | currency:'USD':'$ ':'1.2-2' }}</b></label>
                    <label class="fs-4 text-black mb-3">Please select coverage option in Quote step.</label>
                }
             </div>
            
        </form>
    </div>
</ng-container>